// DS: i6.28
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const PlayVideo: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="72"
      fill="none"
      viewBox="0 0 72 72"
    >
      <path d="M36 2C54.7777 2 70 17.2223 70 36C70 54.7777 54.7777 70 36 70C17.2223 70 2 54.7777 2 36C2 17.2223 17.2223 2 36 2ZM36 6C19.4315 6 6 19.4315 6 36C6 52.5685 19.4315 66 36 66C52.5685 66 66 52.5685 66 36C66 19.4315 52.5685 6 36 6ZM47.8701 35.416L27.2441 47.4824V23.3525L47.8701 35.416Z" fill="currentColor" />
    </svg>
  </IconWrap>
);
PlayVideo.displayName = 'PlayVideo';

export default PlayVideo;
